/* global ApplePaySession */

import React, { PureComponent, Fragment } from 'react'
import { Portal } from 'react-portal'
import { Link } from 'react-router-dom'
import track from 'react-tracking'
import PropTypes from 'prop-types'
import querystring from 'query-string'
import Overlay, { StopPropagation } from '@ynap/overlay'
import BEMHelper from '@ynap/bem-helper'
import { Button, SimpleAsyncButton } from '@ynap/button'
import { Notification, Tooltip } from '@ynap/notification'
import { LineItem, LineItemGroup, LineItemSkeleton } from '@ynap/line-item'
import Totals from '@ynap/totals'
import PromoCodesSection from '../PromoCodesSection/PromoCodesSection'
import { ToggleSection } from '@ynap/toggle'
import EmptyList from '@ynap/empty-list'
import Skeleton from '@ynap/skeleton'
import { ScrollToTopOnMount } from '@ynap/scroll-to-top'
import PaymentCard from '@ynap/payment-card'
import { QuantityStepper } from '@ynap/stepper'
import { RetryErrorPage } from '@ynap/error-page'
import { Provider as AnalyticsProvider } from '@ynap/analytics'
import ViewportObserver from '@ynap/viewport-observer'
import { trackAddRemoveItem } from '@ynap/product-details-page'
import LoyaltyBadgeNotification from '@ynap/loyalty-badge-notification'
import { OptimizelyFeature, withOptimizely, trackPage as trackPageOptimizely } from '@ynap/optimizely-utils'
import { getCookie } from '@ynap/redux-cookies-middleware/src/cookieApi'
import Price from '../Price/Price'
import { getCrisisNotification } from '../../utils/crisis'
import { MetaData } from '../../utils/getMetaData'
import createAnalyticsEvent, { trackCancelApplePay, trackViewMiniPDP } from '../analytics'
import FinishingTouches from '../FinishingTouches/FinishingTouches'
import ConsideredInfo from '../ConsideredInfo/ConsideredInfo'
import { getJITNotification } from '../../utils/jit'
import { trackProceed, trackContinue, trackRemoveAllItems, trackMoveToWishlist } from './createBasketEvent'
import { getRemovedItemsMessage, getRemovedItemsTitle } from './getRemovedItemsMessage'
import { KlarnaOnSiteMessaging, KlarnaExpressButton } from '../Klarna'
import { injectKlarnaScript } from 'app/utils/klarnaUtils'
import { startApplePayBasketSession } from '../../utils/applePaySession'
import DDUAcceptanceForm from '../DDUAcceptanceForm/DDUAcceptanceForm'

const bem = new BEMHelper('Checkout-Basket')
@track()
class Basket extends PureComponent {
    static propTypes = {
        locale: PropTypes.object.isRequired,
        lineItems: PropTypes.arrayOf(PropTypes.object),
        lineItemsIncludingRemoved: PropTypes.arrayOf(PropTypes.object),
        rectifiedQtyItems: PropTypes.arrayOf(PropTypes.object),
        rectifiedItemsList: PropTypes.arrayOf(PropTypes.number),
        soldoutItems: PropTypes.arrayOf(PropTypes.object),
        location: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired,
        totals: PropTypes.shape({
            packaging: PropTypes.string,
            currency: PropTypes.string.isRequired,
            itemTotal: PropTypes.string,
            originalShippingPrice: PropTypes.string,
            finalShippingPrice: PropTypes.string,
            total: PropTypes.string.isRequired,
            promotions: PropTypes.array,
            rewards: PropTypes.array,
            savingsTotal: PropTypes.number,
        }),
        messages: PropTypes.shape({
            basket: PropTypes.shape({
                remove: PropTypes.func,
                removeSuccess: PropTypes.func,
                moveToWishlist: PropTypes.func,
                moveToWishlistSuccess: PropTypes.func,
                alreadyInWishlist: PropTypes.func,
                undo: PropTypes.func,
                continueShopping: PropTypes.func,
                proceedToPurchase: PropTypes.func,
                empty: PropTypes.func,
                orderSummaryTitle: PropTypes.func,
                quantityStepperError: PropTypes.func,
                shippingDelays: PropTypes.func,
                jit: PropTypes.shape({
                    jitMessage1: PropTypes.func.isRequired,
                    jitMessage2: PropTypes.func.isRequired,
                }),
            }),
            errors: PropTypes.shape({
                unknown: PropTypes.func,
                required: PropTypes.func,
                invalid: PropTypes.func,
            }),
            promotionForm: PropTypes.shape({
                code: PropTypes.func,
                apply: PropTypes.func,
            }),
            totals: PropTypes.shape({
                itemTotal: PropTypes.func,
                shipping: PropTypes.func,
                shippingPrice: PropTypes.func,
                packaging: PropTypes.func,
                total: PropTypes.func,
                remove: PropTypes.func,
            }),
        }).isRequired,
        paymentMethods: PropTypes.array,
        continueShoppingPath: PropTypes.string,
        fetchCart: PropTypes.func,
        undoRemoveLineItem: PropTypes.func,
        removeLineItem: PropTypes.func,
        removeLineItems: PropTypes.func,
        removeLineItemError: PropTypes.objectOf(PropTypes.string),
        removeLineItemsError: PropTypes.objectOf(PropTypes.string),
        moveToWishlist: PropTypes.func,
        moveToWishlistError: PropTypes.objectOf(PropTypes.string),
        undoMoveToWishlist: PropTypes.func,
        undoMoveToWishlistError: PropTypes.objectOf(PropTypes.string),
        addPromotion: PropTypes.func,
        removePromotion: PropTypes.func,
        dismissRemoveLineItem: PropTypes.func,
        className: PropTypes.string,
        showContinueShoppingLink: PropTypes.bool,
        orderId: PropTypes.number,
        buyerId: PropTypes.number,
        addItemsToWishlist: PropTypes.func,
        addItemsToWishlistError: PropTypes.objectOf(PropTypes.string),
        savingsTotal: PropTypes.string,
        config: PropTypes.shape({
            enableQuantityStepper: PropTypes.bool,
            flags: PropTypes.object,
        }),
        updateBasketLineItem: PropTypes.func,
        updateLineItemInBasketError: PropTypes.string,
        checkoutAnalytics: PropTypes.object.isRequired,
        addToBagByProductColour: PropTypes.func,
        optimizely: PropTypes.object,
        initialApplePayFlow: PropTypes.func,
        finaleApplePayFlow: PropTypes.func,
        getApplePayRequestSb: PropTypes.func,
        userSummary: PropTypes.object,
        hasJITItems: PropTypes.bool,
    }

    constructor(props) {
        super(props)
        this.fetchAndSetNotification = this.fetchAndSetNotification.bind(this)
        this.toggleproductOverlay = this.toggleproductOverlay.bind(this)
    }

    state = {
        confirmOverlayOpen: false,
        productOverlayOpen: false,
        isRecommendation: false,
        provincesFetched: false,
        showDialog: false,
        pcccValue: '',
        showDDuDialog: false,
        isDDUAccepted: false,
    }

    handlePCCC = (e) => {
        this.setState({ pcccValue: e.target.value })
    }

    closePCCCDialog = (resetPCCC, initializeApplePaySession) => {
        this.setState({ showDialog: !this.state.showDialog })
        initializeApplePaySession(true)
        if (resetPCCC) {
            this.setState({ pcccValue: '' })
        }
    }

    toggleConfirmOverlay = () => {
        const { confirmOverlayOpen } = this.state
        this.setState({ confirmOverlayOpen: !confirmOverlayOpen })
    }

    @track(({ checkoutAnalytics }, state, [item]) => {
        if (!state.productOverlayOpen) return trackViewMiniPDP({ checkoutAnalytics }, item)
    })
    toggleproductOverlay(partNumber, isRecommendation = false) {
        const { productOverlayOpen } = this.state
        this.setState({ overlayPartNumber: partNumber, productOverlayOpen: !productOverlayOpen, isRecommendation })
    }

    @track(({ checkoutAnalytics = {}, lineItemsIncludingRemoved }) =>
        createAnalyticsEvent({
            ...checkoutAnalytics,
            allowEmpty: true,
            pageConfigs: {
                pageName: lineItemsIncludingRemoved && lineItemsIncludingRemoved.length === 0 ? 'basket - no items' : 'basket',
                pageType: 'basket',
                primaryCategory: 'ecommerce',
                subCategory1: 'basket',
                subCategory2: 'basket',
            },
        })
    )
    componentDidMount() {
        const { fetchCart, lineItemsIncludingRemoved, fetchCountries, countries, optimizely } = this.props

        optimizely && trackPageOptimizely(optimizely, 'basket')

        if (document.referrer.includes('/product/')) {
            optimizely?.track?.('pdp_sp')
        }

        if (!countries || Object.keys(countries).length === 0) {
            fetchCountries()
        }

        if (!lineItemsIncludingRemoved) {
            return fetchCart()
        }

        this.handleQueryString()
    }

    componentDidUpdate(prevProps) {
        const { lineItemsIncludingRemoved, countries, fetchProvinces, locale, isFetchingProvinces, config, klarnaClientId, klarnaMerchantId } = this.props
        const { country } = locale
        const { provincesFetched } = this.state
        const { klarna } = config || {}

        if (klarna?.express?.enabledIn?.includes(locale?.country.toLowerCase())) {
            if (klarnaClientId && prevProps.klarnaClientId !== klarnaClientId) {
                injectKlarnaScript(klarna, locale, klarnaClientId)
            }

            if (klarnaMerchantId && prevProps.klarnaMerchantId !== klarnaMerchantId) {
                injectKlarnaScript(klarna, locale.id, klarnaMerchantId, true)
            }
        }

        if (prevProps.lineItemsIncludingRemoved !== lineItemsIncludingRemoved && lineItemsIncludingRemoved) {
            this.handleQueryString()
        }

        if (countries && Object.keys(countries).length > 0 && !countries[`${country}`]?.provinces && !isFetchingProvinces && !provincesFetched) {
            fetchProvinces(country)
            this.setState({ provincesFetched: true })
        }
    }

    @track(({ lineItems, checkoutAnalytics }, state, [item]) => trackRemoveAllItems(item, lineItems.length, checkoutAnalytics))
    onRemoveLineItem(item) {
        const rectifiedQtyItemsIds = this.props?.rectifiedQtyItems?.map((el) => el.partNumber)
        const clearMessages = rectifiedQtyItemsIds?.includes(item.orderItemId)

        this.props.optimizely?.track?.('basket_remove_item', { removedItemQty: item?.quantity })
        this.props.removeLineItem(item.partNumber, item.orderItemId, item.isReservation ? 1 : item.quantity, clearMessages)
    }

    @track(trackProceed)
    onProceed() {
        const { optimizely } = this.props
        optimizely?.track('start_checkout')
    }

    @track(trackContinue)
    onContinue() {}

    @track(({ checkoutAnalytics }, state, [item]) => trackMoveToWishlist(item, checkoutAnalytics))
    onMoveToWishlist(item) {
        this.props.moveToWishlist(item.partNumber, item.orderItemId, false, item.quantity)
        this.props.optimizely?.track?.('basket_movetowl')
    }

    handleQueryString = () => {
        const { location, history, moveToWishlist, lineItemsIncludingRemoved = [], soldoutItems = [], addItemsToWishlist } = this.props
        const { pathname, search } = location
        const { wishlistItem, clearMessages, partNumbers, ...rest } = querystring.parse(search, { arrayFormat: 'comma' })

        if (wishlistItem) {
            const soldOutItem = soldoutItems.find(({ partNumber }) => partNumber === wishlistItem)
            const { quantity, orderItemId } = soldOutItem || lineItemsIncludingRemoved.find(({ partNumber }) => partNumber === wishlistItem) || {}
            quantity && moveToWishlist(wishlistItem, orderItemId, !!soldOutItem, quantity)
        }

        if (partNumbers) {
            const partNumberArr = Array.isArray(partNumbers) ? partNumbers : [partNumbers]
            const wishlistPartNumbers = partNumberArr.map((partNumber) => ({ partNumber }))
            addItemsToWishlist(wishlistPartNumbers, true).then(() => {
                this.fetchAndSetNotification()
            })
        }

        if (clearMessages) {
            this.fetchAndSetNotification()
        }
        const restQs = querystring.stringify(rest)

        if (search.length > 0 && search !== `?${restQs}`) {
            //replace history for above cases to avoid duplicated calls
            history.replace({ pathname, search: restQs })
        }
    }

    fetchAndSetNotification() {
        const { fetchCart, setCheckoutNotification, messages } = this.props

        return fetchCart({ clearMessages: true }).then((cart) => {
            const { orderItem } = cart.payload
            if (orderItem && orderItem.length > 0) {
                setCheckoutNotification('info', messages.cartRectification.bagUpdated(), { autoHideDelay: 3000 })
            }
        })
    }

    renderCheckoutNotification = () => {
        const { checkoutNotification } = this.props
        return checkoutNotification ? (
            <div className={bem('alertContainer', { sticky: checkoutNotification.sticky })}>
                <Notification
                    className={bem('alerts', { sticky: checkoutNotification.sticky })}
                    type={checkoutNotification.type}
                    message={checkoutNotification.message}
                />
            </div>
        ) : null
    }

    handleMoveAllToWishlist = () => {
        const { soldoutItems, addItemsToWishlist } = this.props
        const partNumbers = soldoutItems.filter((item) => !item.alreadyInWishlist).map((item) => ({ partNumber: item.partNumber }))

        addItemsToWishlist(partNumbers, true).then(() => {
            this.fetchAndSetNotification()
        })
    }

    handleRemoveAllClick = () => {
        this.fetchAndSetNotification()
    }

    quantityChange = (item) => (newQuantity) => {
        const { tracking, updateBasketLineItem } = this.props
        const { partNumber, quantity } = item
        tracking.trackEvent(trackAddRemoveItem(item, quantity, newQuantity))
        updateBasketLineItem(partNumber, newQuantity)
    }

    renderConfirmOverlay = () => {
        const {
            messages: {
                basket: { removeAllFromBasket },
            },
            removeLineItems,
            lineItems,
        } = this.props
        const { title, description, cancel, remove } = removeAllFromBasket
        return this.state.confirmOverlayOpen ? (
            <Portal>
                <Overlay title={title()} onClose={this.toggleConfirmOverlay} handleBodyClick={this.toggleConfirmOverlay} className={bem('confirmOverlay')}>
                    <StopPropagation>
                        <div className={bem('confirmOverlay-description')}>{description()}</div>
                        <div className={bem('confirmOverlay-buttons')}>
                            <Button onClick={this.toggleConfirmOverlay} type="secondary">
                                {cancel()}
                            </Button>
                            <Button
                                onClick={() => {
                                    this.toggleConfirmOverlay()
                                    return removeLineItems(lineItems)
                                }}
                                type="primary"
                            >
                                {remove()}
                            </Button>
                        </div>
                    </StopPropagation>
                </Overlay>
            </Portal>
        ) : null
    }

    renderLineItemOverlay = () => {
        const { LineItemEditOverlayContainer, messages, location, sizeGridFeatureToggle, locale, checkoutAnalytics, ...rest } = this.props
        const { overlayPartNumber, isRecommendation } = this.state

        return (
            this.state.productOverlayOpen && (
                <AnalyticsProvider value={{ page: { category: { primaryCategory: 'ecommerce', subCategory1: 'basket' } }, ...checkoutAnalytics }}>
                    <LineItemEditOverlayContainer
                        {...rest}
                        messages={messages}
                        location={location}
                        history={history}
                        partNumber={overlayPartNumber}
                        sizeGridFeatureToggle={sizeGridFeatureToggle}
                        toggleproductOverlay={this.toggleproductOverlay}
                        locale={locale.id}
                        isRecommendation={isRecommendation}
                        country={locale?.country}
                    />
                </AnalyticsProvider>
            )
        )
    }

    totalsExcludeStoreCredit = ({ storeCredit, ...rest }) => ({ ...rest, total: rest.grandTotal }) // eslint-disable-line no-unused-vars

    renderLineItems = (items = []) => {
        const {
            messages,
            undoMoveToWishlist,
            undoMoveToWishlistError = {},
            undoRemoveLineItem,
            config: { enableQuantityStepper },
            showUsTaxUi,
            isFetchingCart,
            updateLineItemInBasketError,
            removeLineItemError = {},
            moveToWishlistError = {},
            rectifiedQtyItems,
            rectifiedItemsList,
            locale: { country },
        } = this.props
        const rectifiedQtyItemsIds = rectifiedQtyItems?.map((el) => el.orderItemId)

        return items.map((item) => {
            const toggleRectificationMsg = rectifiedQtyItemsIds?.includes(Number(item.partNumber)) || rectifiedItemsList?.includes(Number(item.partNumber))

            return item.removed && !rectifiedItemsList?.includes(Number(item.partNumber)) ? (
                <Notification
                    key={item.orderItemId}
                    component="li"
                    type="product"
                    image={item.image}
                    messageChildren={
                        <div>
                            {item.brand && <span className={bem('brand')}>{item.brand}</span>}
                            {item.name && <span className={bem('name')}>{item.name}</span>}
                        </div>
                    }
                    message={
                        item.giftListItemID
                            ? item.alreadyInWishlist
                                ? messages.basket.alreadyInWishlist(item)
                                : messages.basket.moveToWishlistSuccess({ items: item.quantity })
                            : messages.basket.removeSuccess({ items: item.quantity })
                    }
                    className={bem('lineItemreduced')}
                >
                    <div className={bem('actionsReduced', 'notification')}>
                        <Tooltip
                            type="error"
                            message={messages.errors.unknown()}
                            defaultOpen={!!undoMoveToWishlistError[item.partNumber]}
                            key={undoMoveToWishlistError[item.partNumber]}
                        >
                            <Button
                                type="tertiary"
                                className={bem('undo')}
                                onClick={() =>
                                    item.giftListItemID
                                        ? undoMoveToWishlist({
                                              partNumber: item.partNumber,
                                              orderItemId: item.orderItemId,
                                              giftListItemID: !item.alreadyInWishlist && item.giftListItemID,
                                              reservationId: item.reservationId,
                                          })
                                        : undoRemoveLineItem({
                                              partNumber: item.partNumber,
                                              reservationId: item.reservationId,
                                          })
                                }
                            >
                                {messages.basket.undo()}
                            </Button>
                        </Tooltip>
                    </div>
                </Notification>
            ) : (
                <>
                    <LineItem
                        key={item.orderItemId}
                        {...item}
                        className={bem('lineItem')}
                        messages={messages}
                        quantity={!enableQuantityStepper && item.quantity}
                        onClick={() => this.toggleproductOverlay(item.partNumber)}
                        priceComponent={Price}
                        showUsTaxUi={showUsTaxUi}
                        isJIT={item.isJIT}
                        country={country}
                    >
                        {item.finalSale && <Notification className={bem('finalSale')} type="info" message={messages.notifications.finalSale()} />}
                        {enableQuantityStepper && (
                            <QuantityStepper
                                className={bem('quantity-stepper')}
                                initialQuantity={item.quantity}
                                maxQuantity={item.quantityInStock}
                                messages={messages}
                                onChange={this.quantityChange(item)}
                                disabled={!item.quantityInStock || isFetchingCart}
                                shouldReset={!!updateLineItemInBasketError}
                            />
                        )}
                        {item.isReservation && (
                            <Notification
                                className={bem('info')}
                                type="info"
                                message={messages.basket.reservation({
                                    expiryDate: item.reservationExpiryDate.toUpperCase(),
                                })}
                            />
                        )}
                        {item.isHazardous && <Notification className={bem('info')} type="info" message={messages.notifications.hazmat()} />}

                        <div className={bem('actions', 'lineItem')}>
                            <Tooltip
                                className={bem('tooltip')}
                                type="error"
                                message={messages.errors.unknown()}
                                defaultOpen={!!removeLineItemError[item.partNumber]}
                                key={removeLineItemError[item.partNumber]}
                            >
                                <Button type="tertiary" className={bem('remove')} onClick={() => this.onRemoveLineItem(item)}>
                                    {messages.basket.remove()}
                                </Button>
                            </Tooltip>

                            <Tooltip
                                className={bem('tooltip')}
                                type="error"
                                message={moveToWishlistError[item.partNumber] === 'wishlist full' ? messages.errors.maxWishList() : messages.errors.unknown()}
                                defaultOpen={!!moveToWishlistError[item.partNumber]}
                                key={moveToWishlistError[item.partNumber]}
                                notificationClassName={bem('wishListError')}
                            >
                                <Button
                                    type="tertiary"
                                    className={bem('moveToWishlist')}
                                    onClick={() => {
                                        this.onMoveToWishlist(item)
                                    }}
                                >
                                    {messages.basket.moveToWishlist()}
                                </Button>
                            </Tooltip>
                        </div>
                        {updateLineItemInBasketError?.error && updateLineItemInBasketError?.partNumber === item.partNumber && (
                            <Notification type="error" message={messages.basket.quantityStepperError()} />
                        )}
                        {toggleRectificationMsg && <Notification className={bem('info')} type="info" message={messages.basket.partiallyRectMsg()} />}
                    </LineItem>
                </>
            )
        })
    }

    renderKlarnaExpress() {
        const { locale, setKlarnaExpress, setShippingAddress, setPaymentMethod, klarnaClientId, config = {}, totals, klarnaMerchantId, history } = this.props

        const shouldEnableKlarnaExpress = klarnaMerchantId && klarnaClientId && config.klarna?.express?.enabledIn.includes(locale?.country.toLowerCase())

        if (!shouldEnableKlarnaExpress) return null

        return (
            <div>
                <KlarnaExpressButton
                    setKlarnaExpress={setKlarnaExpress}
                    setShippingAddress={setShippingAddress}
                    setPaymentMethod={setPaymentMethod}
                    locale={locale}
                    history={history}
                />
                <div className={bem('klarnaOnSiteComp')}>
                    <KlarnaOnSiteMessaging locale={locale} total={totals.rawTotal * 100} />
                </div>
            </div>
        )
    }

    render() {
        const {
            activePromotions,
            addPromotion,
            addItemsToWishlistError,
            addToBagState,
            addToBagByProductColour,
            addToBagWithCartSync,
            applePayCheckout,
            checkPromotion,
            checkoutAnalytics,
            className,
            continueShoppingPath,
            crisisMessages,
            fetchCart,
            fetchCartError,
            fetchPromotions,
            finaleApplePayFlow,
            getApplePayRequest,
            getApplePayRequestSb,
            globalConfig,
            history,
            initialApplePayFlow,
            isCSR,
            isPostSplit,
            jitMessages,
            locale,
            lineItemsIncludingRemoved,
            lineItems,
            localItemsIncRemoved = [],
            messages,
            numItems,
            paymentMethods,
            promotionsCheckerInfo,
            config,
            remoteItemsIncRemoved = [],
            removedItemsRestrictions,
            removeLineItemsError,
            removePromotion,
            setApplePayCancel,
            setCheckoutError,
            setCheckoutNotification,
            setShippingAddress,
            setShippingMethod,
            showContinueShoppingLink = true,
            shippingOptions,
            soldoutItems,
            tracking,
            totals,
            updatePaymentMethod,
            userStatus,
            createFastUser,
            transactionTotal,
            availableStoreCredit,
            userSummary = {},
            hasJITItems,
            dduAcceptance,
            deliveryDuty,
        } = this.props

        const {
            flags = {},
            finishingTouches,
            legalMessage,
            omnibusROWEnabled,
            minimumPriceCountries,
            omnibusMessageEnabled,
            applepay,
            tierExpansionEnabled,
        } = config

        const bagIsEmpty = lineItemsIncludingRemoved && lineItemsIncludingRemoved.length === 0
        const hasSoldOut = soldoutItems && soldoutItems.length !== 0
        const cartReady = !!lineItemsIncludingRemoved
        const consideredMessaging = flags?.enableConsidered ? messages?.considered?.consideredInfo : null
        const { country } = locale
        const countryFromLocale = country?.toUpperCase()
        const showUsTaxUi = countryFromLocale === 'US' && flags?.showUsTaxUi
        const genderPreferenceCookie = getCookie('ton-shop') || 'womens'
        const continueShoppingPathUrl = continueShoppingPath.replace('{gender}', genderPreferenceCookie === 'mens' ? 'mens/' : '')
        const enableLegalMessage = legalMessage
            ? legalMessage.enabled && messages.basket.legalMessage && legalMessage.countries.includes(countryFromLocale)
            : false
        const isEUcountry = minimumPriceCountries?.includes(country?.toUpperCase())
        const containsSaleExclusiveItems = [...remoteItemsIncRemoved, ...localItemsIncRemoved].some((item) => item.saleExclusive)
        const applyOmnibusMessage = omnibusMessageEnabled && isEUcountry && containsSaleExclusiveItems
        const { loyaltySegment, loyaltyConsent } = userSummary || {}
        const { showDialog, pcccValue } = this.state
        const isPCCCValid = /^P[0-9]{12}$/.test(pcccValue)
        const isDduAcceptanceRequired = !!dduAcceptance && deliveryDuty == 'DDU'

        const initializeApplePaySession = (orderLevelTaxes) => {
            const origin = typeof window !== 'undefined' ? window.location.origin : ''
            const paymentAuthoriseUrl = `${origin}/${locale.id}/checkout/authorise`.toLowerCase()

            const applePayRequest = getApplePayRequestSb?.({
                type: 'basket',
                orderLevelTaxes,
            })
            const applePaySession = new ApplePaySession(8, applePayRequest)

            const params = {
                applePayCheckout,
                getApplePayRequestSb,
                getApplePayRequest,
                finaleApplePayFlow,
                history,
                initialApplePayFlow: () =>
                    initialApplePayFlow({
                        returnUrl: paymentAuthoriseUrl,
                        isApplePay: true,
                        applePayValidationUrl: applepay?.applePayValidationUrl,
                        userStatus,
                    }),
                orderLevelTaxes,
                redirect: `/${locale.id}/checkout/confirmation`,
                setApplePayCancel,
                setCheckoutError,
                setShippingAddress,
                setShippingMethod,
                trackCancelApplePay,
                updatePaymentMethod,
                createFastUser,
                config,
                messages,
                globalConfig,
                PCCC: this.state.pcccValue,
            }
            startApplePayBasketSession(applePaySession, params)
        }

        if (fetchCartError && !lineItemsIncludingRemoved) {
            return (
                <div className={bem(null, null, className)}>
                    <div className={bem('emptyBasket')}>
                        <div className={bem('header')}>
                            <h2 className={bem('title')}>{messages.basket.title()}</h2>
                        </div>
                        <RetryErrorPage className={bem('errorState')} messages={messages} maxRetries={0} action={() => fetchCart()} error={fetchCartError} />
                    </div>
                </div>
            )
        }

        const handleAPCta = () => {
            const pcccEnabledInSB = country === 'KR' && flags.applePayPCCCinSB

            if ((!pcccEnabledInSB || isPCCCValid) && !isDduAcceptanceRequired) {
                initializeApplePaySession(true)
            } else if (isDduAcceptanceRequired) {
                this.setState({ showDDUDialog: true })
            } else {
                this.setState({ showDialog: true })
            }
        }

        const closeDDUDialog = (initializeApplePaySession) => {
            this.setState({ showDDUDialog: !this.state.showDDUDialog })
            initializeApplePaySession(true)
        }

        const getCheckboxValue = (checkboxValue) => {
            this.setState({ isDDUAccepted: checkboxValue })
        }

        const applePaInSBExperiment = () => {
            const ua = navigator.userAgent
            const { showDDUDialog, isDDUAccepted } = this.state
            const isSafari = /Safari/.test(ua) && !/Chrome/.test(ua) && !/Chromium/.test(ua)
            const payWithStoreCredit = transactionTotal <= availableStoreCredit
            const renderApplePayCta = ({ applePaySbEnabled }) =>
                applePaySbEnabled && (window?.safari || isSafari) && paymentMethods.includes('APPLEPAY') && !payWithStoreCredit

            return (
                <OptimizelyFeature
                    feature={[
                        'WEB00073_applepay_shoppingbag_web',
                        'WEB00074_applepay_shoppingbag_mob',
                        'WEB00113_applepay_shoppingbag_web',
                        'WEB00072_applepay_shoppingbag_mob',
                        'WEB00320_applepay_shoppingbag_web',
                        'WEB00321_applepay_shoppingbag_mob',
                    ]}
                >
                    {(props) => {
                        const { variables = {} } = props

                        return renderApplePayCta(variables) ? (
                            <div className={bem('applePay')}>
                                <SimpleAsyncButton
                                    copy={messages.basket.applePay.payWith()}
                                    type={'applepay'}
                                    className={bem('proceed')}
                                    loading={false}
                                    onClick={handleAPCta}
                                />
                                {showDDUDialog && (
                                    <Portal>
                                        <Overlay
                                            title={messages.basket.applePay.title()}
                                            handleBodyClick={closeDDUDialog}
                                            onClose={closeDDUDialog}
                                            className={bem('dduOverlay')}
                                        >
                                            <div className={bem('pcccInputWrapper')}>
                                                <DDUAcceptanceForm
                                                    className={bem('dduCheckbox')}
                                                    messages={messages}
                                                    deliveryDuty={deliveryDuty}
                                                    initialValues={{
                                                        acceptAdditionalCosts: dduAcceptance,
                                                        checkoutAnalytics,
                                                    }}
                                                    checkoutAnalytics={checkoutAnalytics}
                                                    getCheckboxValue={getCheckboxValue}
                                                />
                                                <SimpleAsyncButton
                                                    onClick={() => closeDDUDialog(initializeApplePaySession)}
                                                    copy={messages.basket.applePay.payWith()}
                                                    type={'applepay'}
                                                    className={bem('proceed')}
                                                    loading={false}
                                                    disabled={!isDDUAccepted}
                                                />
                                            </div>
                                        </Overlay>
                                    </Portal>
                                )}
                                {showDialog && !isDduAcceptanceRequired && (
                                    <Portal>
                                        <Overlay
                                            title={messages.basket.pcccDialogTitle()}
                                            handleBodyClick={() => this.closePCCCDialog(false)}
                                            onClose={() => this.closePCCCDialog(true)}
                                        >
                                            <div className={bem('pcccInputWrapper')}>
                                                <label>{messages.basket.pcccInputLabel()}</label>
                                                <input
                                                    type="text"
                                                    onChange={this.handlePCCC}
                                                    name="pccc"
                                                    id="pccc"
                                                    className={bem('pcccInput')}
                                                    value={this.state.pcccValue}
                                                    maxLength={13}
                                                />
                                                <div className={bem('invalidPCCCSpace')}>
                                                    {pcccValue.length > 0 && !isPCCCValid ? (
                                                        <div className={bem('pcccInputError')}>{messages.basket.invalidPCCC()}</div>
                                                    ) : null}
                                                </div>
                                                <Button
                                                    onClick={() => this.closePCCCDialog(false, initializeApplePaySession)}
                                                    type="primary"
                                                    className={bem('pcccSubmit')}
                                                    disabled={!isPCCCValid}
                                                >
                                                    {messages.basket.submitPCCC()}
                                                </Button>
                                            </div>
                                        </Overlay>
                                    </Portal>
                                )}
                            </div>
                        ) : null
                    }}
                </OptimizelyFeature>
            )
        }

        return (
            <div className={bem(null, null, className)}>
                <MetaData title={messages.basket.title()} brandId={globalConfig.application.brandId} />
                {this.renderLineItemOverlay()}
                <ScrollToTopOnMount />
                {bagIsEmpty && !hasSoldOut ? (
                    <div className={bem('emptyBasket')}>
                        {this.renderCheckoutNotification()}
                        <EmptyList className={bem('empty')} icon={<div className={bem('emptyIcon')} />} details={messages.basket.empty()}>
                            {showContinueShoppingLink && (
                                <Button
                                    component="a"
                                    href={`/${locale.id}${continueShoppingPathUrl}`}
                                    className={bem('continueLink')}
                                    onClick={() => this.onContinue()}
                                >
                                    {messages.basket.continueLink()}
                                </Button>
                            )}
                        </EmptyList>
                    </div>
                ) : (
                    <div className={bem('basketWithProducts')}>
                        {this.renderCheckoutNotification()}
                        <div className={bem('header')}>
                            <h2 className={bem('title')}>{messages.basket.title()}</h2>
                            {lineItems ? (
                                <span className={bem('itemCount')}>{messages.basket.items({ numItems })}</span>
                            ) : (
                                <Skeleton align="left" className={bem('skeletonNumItems')} />
                            )}
                        </div>

                        <div className={bem('itemsAndTotals')}>
                            <div className={bem('productsWrapper')}>
                                <div className={bem('notificationsWrapper')}>{cartReady && getCrisisNotification(bem, true, crisisMessages)}</div>
                                <div className={bem('lineItemGroupWrapper')}>
                                    {cartReady ? (
                                        <Fragment>
                                            {!bagIsEmpty ? (
                                                <LineItemGroup className={bem('lineItemGroup')}>
                                                    <div className={bem('messagesWrapper')}>{getCrisisNotification(bem, true, crisisMessages)}</div>
                                                    {flags?.postSplitEnabled ? (
                                                        <Fragment>
                                                            {this.renderLineItems(localItemsIncRemoved)}
                                                            {isPostSplit && <li className={bem('postshipDivider')}>{messages.basket.jit.postship?.()}</li>}
                                                            {this.renderLineItems(remoteItemsIncRemoved)}
                                                        </Fragment>
                                                    ) : (
                                                        <Fragment>
                                                            {this.renderLineItems(remoteItemsIncRemoved)}
                                                            {this.renderLineItems(localItemsIncRemoved)}
                                                        </Fragment>
                                                    )}
                                                </LineItemGroup>
                                            ) : null}
                                            {lineItems?.length >= config?.basketOptions?.removeAllThreshold ? (
                                                <Tooltip
                                                    type="error"
                                                    className={bem('removeAllItems')}
                                                    message={messages.errors.unknown()}
                                                    open={!!removeLineItemsError}
                                                >
                                                    <Button type="tertiary" onClick={this.toggleConfirmOverlay}>
                                                        {messages.basket.removeAllFromBasket.title()}
                                                    </Button>
                                                    {this.renderConfirmOverlay()}
                                                </Tooltip>
                                            ) : null}

                                            {hasSoldOut ? (
                                                <ToggleSection
                                                    className={bem('soldout-toggle')}
                                                    title={getRemovedItemsTitle(messages, removedItemsRestrictions)({ items: soldoutItems.length })}
                                                    defaultOpen
                                                >
                                                    <Notification
                                                        className={bem('alerts', 'soldout')}
                                                        type="info"
                                                        message={getRemovedItemsMessage(messages, removedItemsRestrictions)()}
                                                    />
                                                    <div className={bem('listActions')}>
                                                        <Tooltip
                                                            type="error"
                                                            message={messages.errors.unknown()}
                                                            defaultOpen={!!fetchCartError}
                                                            key={fetchCartError?.message}
                                                        >
                                                            <Button type="tertiary" className={bem('remove', 'soldout')} onClick={this.handleRemoveAllClick}>
                                                                {messages.basket.removeAll()}
                                                            </Button>
                                                        </Tooltip>
                                                        <Tooltip
                                                            type="error"
                                                            message={
                                                                messages.notifications?.[addItemsToWishlistError]
                                                                    ? messages.notifications[addItemsToWishlistError]()
                                                                    : messages.errors.unknown()
                                                            }
                                                            defaultOpen={!!addItemsToWishlistError}
                                                            key={addItemsToWishlistError}
                                                            notificationClassName={bem('wishListError')}
                                                        >
                                                            <Button
                                                                type="tertiary"
                                                                className={bem('moveToWishlist', 'soldout')}
                                                                onClick={this.handleMoveAllToWishlist}
                                                            >
                                                                {messages.basket.moveAllToWishlist()}
                                                            </Button>
                                                        </Tooltip>
                                                    </div>
                                                    <LineItemGroup className={bem('lineItemGroup')}>
                                                        {soldoutItems.map((item) => (
                                                            <LineItem
                                                                key={item.partNumber}
                                                                {...item}
                                                                className={bem('lineItem')}
                                                                messages={messages}
                                                                showUsTaxUi={showUsTaxUi}
                                                                country={locale?.country}
                                                            />
                                                        ))}
                                                    </LineItemGroup>
                                                </ToggleSection>
                                            ) : null}
                                            {enableLegalMessage && <p className={bem('legal')}>{messages.basket.legalMessage()}</p>}
                                            {applyOmnibusMessage && <div className={bem('lowestPriceMessage')}>{messages?.price?.minimumPriceEqual()}</div>}
                                        </Fragment>
                                    ) : (
                                        <Fragment>
                                            <LineItemSkeleton className={bem('lineItem')} />
                                            <LineItemSkeleton className={bem('secondSkeleton')} />
                                        </Fragment>
                                    )}
                                </div>
                            </div>
                            <div className={bem('totalsWrapper')}>
                                <div className={bem('totals')}>
                                    {messages.basket.orderSummaryTitle && (
                                        <span className={bem('orderSummaryTitle')}>{messages.basket.orderSummaryTitle()}</span>
                                    )}
                                    {totals ? (
                                        <Fragment>
                                            <Totals
                                                className={bem('summary')}
                                                {...this.totalsExcludeStoreCredit(totals)}
                                                rewards={totals.rewards || []}
                                                messages={messages}
                                                enablePromotions={true}
                                                showUsTaxUi={showUsTaxUi}
                                                displaySavingsExplanation={locale?.country !== 'US' && omnibusROWEnabled ? true : false}
                                            />
                                            {tierExpansionEnabled && loyaltySegment !== 'eipplatinum' ? (
                                                <LoyaltyBadgeNotification
                                                    className={bem('loyaltyMessage')}
                                                    tier={loyaltyConsent === 'true' ? loyaltySegment : 'guest'}
                                                    tracking={tracking}
                                                    isExclusiveBadge={false}
                                                    withoutLink={loyaltyConsent === 'true' ? loyaltySegment : false}
                                                />
                                            ) : null}
                                            <PromoCodesSection
                                                addPromotion={addPromotion}
                                                removePromotion={removePromotion}
                                                promotions={totals?.promotions}
                                                setCheckoutNotification={setCheckoutNotification}
                                                checkoutAnalytics={checkoutAnalytics}
                                                activePromotions={activePromotions}
                                                promotionsCheckerInfo={promotionsCheckerInfo}
                                                fetchPromotions={fetchPromotions}
                                                checkPromotion={checkPromotion}
                                                isCSR={isCSR}
                                                config={config}
                                                messages={messages}
                                            />
                                        </Fragment>
                                    ) : (
                                        <Skeleton count={3} className={bem('skeletonTotals')} />
                                    )}
                                    {hasJITItems && !isPostSplit && getJITNotification(jitMessages, 'shoppingBagA', bem)}
                                    {lineItems && lineItems.length > 0 ? (
                                        <ViewportObserver threshold={0} keepObserving={true}>
                                            {(intersected) => {
                                                const easyProceedModifierOnIntersect = !intersected ? bem('easyProceed') : ''

                                                var elements = document.getElementsByTagName('footer')
                                                for (var i = 0; i < elements.length; i++) {
                                                    elements[i].classList.add(bem('easyProceedFooterPadding'))
                                                }

                                                return (
                                                    <>
                                                        <div className={easyProceedModifierOnIntersect}>
                                                            <Button
                                                                type="primary"
                                                                className={bem('proceed')}
                                                                component={Link}
                                                                onClick={() => this.onProceed()}
                                                                to={`/${locale.id}/checkout/login`}
                                                            >
                                                                {messages.basket.proceedToPurchase()}
                                                            </Button>
                                                        </div>
                                                        {this.renderKlarnaExpress()}
                                                        {applePaInSBExperiment()}
                                                    </>
                                                )
                                            }}
                                        </ViewportObserver>
                                    ) : null}
                                    <OptimizelyFeature feature={['WEB00712_noklarna_cart_web_mob', 'WEB00713_noklarna_cart_web_mob']}>
                                        {(props) => {
                                            const { disableKlarna } = props.variables || {}

                                            return (
                                                <ul className={bem('paymentMethods')}>
                                                    {paymentMethods?.map((cardType) => {
                                                        if (disableKlarna && cardType === 'KLARNA_PAY_NOW') return
                                                        return (
                                                            <PaymentCard
                                                                className={bem('cardType', cardType)}
                                                                card={cardType.replace('_', '').toLowerCase()}
                                                                key={cardType}
                                                            />
                                                        )
                                                    })}
                                                </ul>
                                            )
                                        }}
                                    </OptimizelyFeature>
                                </div>
                                {flags?.enableConsidered && totals ? (
                                    <ConsideredInfo
                                        orderConfirmation={false}
                                        consideredBadge={messages.considered.badge()}
                                        title={consideredMessaging.consideredShipping.title()}
                                        subTitle={consideredMessaging.consideredShipping.subTitle()}
                                        bodyTextOne={consideredMessaging.consideredShipping.recycleInformation()}
                                    />
                                ) : null}
                                {finishingTouches?.enabled ? (
                                    <FinishingTouches
                                        messages={messages}
                                        addToBagByProductColour={addToBagByProductColour}
                                        addToBagState={addToBagState}
                                        tracking={tracking}
                                        cartReady={cartReady}
                                        config={finishingTouches}
                                        globalConfig={globalConfig}
                                        imagesphereAspectRatio={config?.aspectRatio?.imagesphere}
                                        locale={locale}
                                        excludeIds={lineItemsIncludingRemoved?.map((l) => l.productId) ?? []}
                                        toggleproductOverlay={this.toggleproductOverlay}
                                    />
                                ) : null}
                            </div>
                        </div>
                    </div>
                )}
            </div>
        )
    }
}

export default withOptimizely(Basket)
